import React, { useState, useEffect } from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import TablaGeneral from "../../components/TablaGeneral";
import Loader from "../../components/Loader";
import configTable from "../../hook/configTable";
import { apiFetch } from "../../utils/api";

const ClientesPage = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [datos, setDatos] = useState([])
  const [error, setError] = useState("")

  const [datosTabla] = useState({
    titulo: "Clientes",
    ruta: "/cliente",
    esAgregar: false,
    esEditar: false,
    esEliminar: false,
    configTable: configTable
  })

  const [cabecera] = useState([
    { title: "ID", key: "id" },
    { title: "NOMBRE", key: "nombre" },
    { title: "APELLIDO", key: "apellido" },
    { title: "CORREO", key: "email" },
    { title: "TELÉFONO", key: "telefono" },
    { title: "FECHA ALTA", key: "createdAt", isDate: true },
  ]);

  const cargarDatos = async () => {
    setIsLoading(true);
    setError("");
    try {
      const data = await apiFetch("/api/clients", { method: "GET" });
      console.log(data);
      if(data.status){
        const clientes = Array.isArray(data.data)
          ? data.data
          : Array.isArray(data.items)
            ? data.items
            : Array.isArray(data.rows)
              ? data.rows
              : [];
        setDatos(clientes);
      } else {
        setDatos([]);
        setError(data.message || "No se pudieron cargar los clientes.");
      }
    } catch (error) {
      console.error('Error:', error);
      setDatos([]);
      setError(error.message || "No se pudieron cargar los clientes.");
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    cargarDatos();
  }, []);
  return (
    <>
      <MasterLayout>
      { isLoading ? <Loader /> : (
        <>
          { error && (
            <div className="alert alert-warning" role="alert">
              {error}
            </div>
          )}
          <TablaGeneral datosTabla={datosTabla} datos={datos} cabecera={cabecera}/>
        </>
      )}
      </MasterLayout>
    </>
  );
};

export default ClientesPage;
